<template>
<v-col class="sortable--drop--filtered pt-1" v-if="shipmentSchedule != null" cols="4" >
  <template v-for="(stop, index) in shipmentSchedule.stops">
    <v-timeline
      class="pa-1"
      dense
      :key="`stop_${stop.location.id}_${stop.type}_${stop.stopIndex}`"
    >
      <!-- <v-row v-if="connection.distance === undefined" class="pa-0" no-gutters>
        <v-col cols="12">
          <div class="v-timeline-item">
            <span class="customTextDot distance placeholderLoader">
              <span style="color: transparent;">
                loading
              </span>
            </span>
          </div>
        </v-col>
        <v-col  cols="12">
          <div class="v-timeline-item dateTimeLoading">
            <span class="customTextDot placeholderLoader">
              <span style="color: transparent;">
                loading
              </span>
            </span>
            <span class="customTextDot date placeholderLoader">
              <span style="color: transparent;">
                loading
              </span>
            </span>
          </div>
        </v-col>
      </v-row> -->
      <v-row class="pa-0" no-gutters>
        <DropDatetimeItem :dateTime="{ ...stop, coordinates: stop.location.coordinates}"/>
        <v-col cols="12"
          v-if="index != shipmentSchedule.stops.length - 1"
        >
          <div class="v-timeline-item">
            <span class="customTextDot distance">
              {{ findConnection(stop.stopIndex).distance | filterDistance }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-timeline>
  </template>
</v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import moment from 'moment-timezone'
import DropDatetimeItem from '@/components/planner/DropDatetimeItem'
import { plannerHelpers } from '@/_helpers'
// import { uuid } from 'vue-uuid'
export default {
  name: 'TimeLineShipmentDrops',
  components: {
    DropDatetimeItem
  },
  props: {
    locations: { type: Array, default: () => [] },
    shipmentID: { type: String, default: null }
  },
  methods: {
    ...mapActions({
      plannerSetShipmentSchedule: 'plannerSetShipmentSchedule'
    }),
    findConnection(stopIndex) {
      return this.shipmentSchedule.connections.find(({ stopIndexFrom }) => {
        return stopIndexFrom === stopIndex
      })
    }
  },
  computed: {
    ...mapGetters([
      'getPlannerDoc',
      'getPlannerScheduleByShipmentID',
      'getPlannerDropsObjectByShipmentID'
    ]),
    shipmentSchedule () {
      return this.getPlannerScheduleByShipmentID(this.shipmentID)
    }
  },
  watch: {
    getPlannerDoc: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val != null) {
          this.plannerSetShipmentSchedule({ doc: val, shipmentID: this.shipmentID, drops: this.getPlannerDropsObjectByShipmentID(this.shipmentID) })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-timeline-item {
    padding: 0;
    position: relative;
    height: 22px;
    &.dateTimeLoading {
      height: 50px;
    }
    .customTextDot {
      &.placeholderLoader {
        max-height: 10px;
        min-width: 80%;
        &.distance {
          min-width: 60%;
        }
      }
      font-size: 12px;
      font-weight: bold;
      background-color: #eeeeee;
      color: #212121;
      position: absolute;
      text-align: center;
      display: inline-block;
      left: 0;
      top: 0;
      &.loading {
        left: 2px;
      }
      &.date {
        top: 20px;
        color: #777777;
      }
      .dropCardTitle {
        &.overflowEllipsis {
          max-width: 90%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
        }
        font-size: 12px;
        font-weight: bold;
        color: #212121;
      }
      .dropCardSubTitle {
        display: inline-block;
        font-size: 10px;
        font-weight: bold;
        color: #777777;
      }
    }
  }
</style>
